<template>
    <div v-show="shippingAddress && !isLoadingAddresses && !isLoadingShippingAddress">
        <h2>Mon mode de livraison</h2>

        <div v-if="0 === choices.length">Pas de moyens de livraisons disponibles</div>
        <div v-else>
            <div v-for="choice in choices">
                <ponroy-order-input-carrier
                        v-model="carrier"
                        :key="choice.value"
                        :value="choice.value"
                        :name="name"
                        :id="id"
                        :countries="JSON.parse(choice.attr['data-countries'])"
                        :isColissimo="isColissimo(choice.attr['data-type'])"
                        :isRelay="isRelay(choice.attr['data-type'])"
                        :label="choice.label"
                >

                </ponroy-order-input-carrier>
            </div>
        </div>
    </div>
</template>
<script>
    import store from '../../store';
    import {mapState, mapActions, mapGetters} from 'vuex';

    const OrderCarrier = {
        name: 'ponroy-order-carrier',
        store,
        props: {
            value: {
                required: true,
            },
            id: {
                required: true,
            },
            name: {
                required: true,
            },
            choices: {
                type: Object,
                required: true,
            }
        },
        data: function () {
           return {
               carrier: {
                   value: "",
                   isRelay: false,
               },
           }
        },
        methods: {
            ...mapActions('order', ['addShippingAddress']),
            isRelay(type) {
                return ['colissimo_relay'].includes(type);
            },
            isColissimo(type){
                return ['colissimo_int', 'colissimo_om', 'colissimo_home', 'colissimo_relay'].includes(type);
            }
        },
        computed: {
            ...mapGetters('order', ['shippingAddress', 'isLoadingShippingAddress', 'isLoadingAddresses']),
        },
        watch: {
            shippingAddress(value) {
                if (value) {
                    let forcedCarrier = null;
                    let country = value.country;
                    for(let k in this.choices) {
                        let countries = JSON.parse(this.choices[k].attr['data-countries']);
                        for (let c in countries) {
                            if (country.id === countries[c].id) {
                                forcedCarrier = this.choices[k];
                                break;
                            }
                        }
                        if (null !== forcedCarrier) {
                            break;
                        }
                    }

                    if (null !== forcedCarrier) {
                        this.carrier.value = forcedCarrier.value;
                        this.carrier.isRelay = this.isRelay(forcedCarrier.attr['data-type']);
                        this.$store.commit('order/SET_CARRIER', this.carrier);
                    } else {
                        this.$store.commit('order/SET_CARRIER', null);
                    }

                } else {
                    this.$store.commit('order/SET_CARRIER', null);
                }
            },
            carrier(value) {
                this.$store.commit('order/SET_CARRIER', value);
            }
        },
    };

    export default OrderCarrier;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/OrderCarrier.vue